export default __webpack_public_path__ + "static/media/5c9ce734bb9e03ae92cc4a6593debfa3.svg";